<div class="p-modal-body05">
  <asw-block-slider id="payment-details-slider">
    <div class="slider-frame01" #scrollPanel>
      <div class="p-fare-rule-detail-panel">
        <div *ngFor="let item of data; index as i" class="p-fare-rule-detail-panel__item">
          <asw-payment-details-breakdown-item
            [data]="item"
            [index]="i"
            [isCanada]="isCanada"
            [isMalaysia]="isMalaysia"
            [mTaxMsgs]="mTaxMsgs"
            [paymentDetailsAwardData]="paymentDetailsAwardData"
          ></asw-payment-details-breakdown-item>
        </div>
      </div>
    </div>
  </asw-block-slider>
</div>
